var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAndroidIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252.03 338.74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#444;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.21,284,27.43,244.45,80.18,49.74,226,89.24ZM229.8,35.08l-125.59-34a30.08,30.08,0,0,0-36.9,21.17L1.05,266.77a30.09,30.09,0,0,0,21.18,36.9l125.58,34a30.09,30.09,0,0,0,36.91-21.16L251.06,71.65A30.07,30.07,0,0,0,229.8,35.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M111.13,145.52l10,18,33.25-17.74,9.18,17.38L121.92,185.7l-8.33,4.52-.32-.09-4.74-8.73L94,155.1Zm-1.66,84.9a66.68,66.68,0,1,0-40.41-31.18A66.73,66.73,0,0,0,109.47,230.42Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroidIc);
export default __webpack_public_path__ + "static/media/android-ic.ab70a29b07cfa66e3143e0836c0befbe.svg";
export { ForwardRef as ReactComponent };